/**
 * API services
 */

import API from './API';

/* =========================
   AUTH
========================= */
export const logInService = async (data) => API.post('/auth/login', data);

/* =========================
   EMPLOYEES
========================= */
export const addEmployeeService = async (data) => API.post('/employee/add', data);

export const updateProfileService = async (data) => API.put('/employee/profile/update', data);

export const getAllEmployeeService = async () => API.get('/employee/list');

export const deleteEmployeeService = async (data) => API.put(`/employee/inactive/${data.id}`, data);

/**
 * Get employee details
 * @param {string} id - employee id
 * @param {boolean} isDetailForEdit - determines endpoint
 */
export const getEmployeeDetailService = async (id, isDetailForEdit) => {
	const endpoint = isDetailForEdit ? `/employee/detail/${id}` : `/employee/${id}`;

	return API.get(endpoint);
};

export const updateEmployeeService = async (id, data) => API.put(`/employee/edit/${id}`, data);

export const removeEmployeeImageService = async (id) => API.delete(`/employee/destroy-image/${id}`);

export const removeEmployeeDocumentService = async (id) =>
	API.delete(`/employee/destroy-document/${id}`);

export const deleteDependentService = async (id) => API.delete(`/employee/dependent/${id}`);

export const deleteAllowanceService = async (id) => API.delete(`/employee/allowance/${id}`);

export const getCurrentEmployeeService = async () => API.get('/users/me'); // TODO: Add permission for this API

/* =========================
   PERMISSIONS
========================= */
export const addPermissionService = async (data) => API.post('/permissions/add', data); // TODO: permission required

export const getPermissionsService = async () => API.get('/permissions/list'); // TODO: permission required

export const updatePermissionService = async (id, data) => API.put(`/permissions/edit/${id}`, data); // FIXED missing slash

export const deletePermissionService = async (id) => API.delete(`/permissions/delete/${id}`); // TODO: permission required

/* =========================
   ROLES
========================= */
export const addRoleService = async (data) => API.post('/role/add', data);

export const getRoleService = async () => API.get('/role/list');

export const updateRoleService = async (id, data) => API.put(`/role/edit/${id}`, data);

export const inactiveRoleService = async (id, data) => API.put(`/role/inactive/${id}`, data);

/* =========================
   DROPDOWNS
========================= */
export const getEmployeeLineManager = async () => API.get('/dropdown/employees');

export const employmentTypesDropdown = async () => API.get('/dropdown/employment-types');

export const getNoticePeriods = async () => API.get('/dropdown/notice-period');

export const rolesAndDepertmentService = async () => API.get('/dropdown/roles');

/* =========================
   ATTENDANCE
========================= */
export const fetchEmployeesForAttendance = async (data) => API.post('/attendance/pending', data);

export const markAttendanceService = async (data) => API.post('/attendance/mark', data); // TODO: permission required

export const getAttendenceService = async (data) => API.post('/attendance/list', data);

export const attendanceDetail = async (data) => API.post(`/attendance/detail/${data?.id}`, data);

export const updateAttendanceService = async (id, data) => API.put(`/attendance/edit/${id}`, data);

export const syncAttendanceService = async (data) => API.post('/attendance/sync', data); // TODO: permission required

/* =========================
   LEAVES
========================= */
export const addLeaveService = async (data) => API.post('/leaves/types', data); // TODO: permission required

export const getLeaveService = async () => API.get('/leaves/types');

export const getLeaveBalanceService = async (data) => API.post('/leaves/balance', data);

export const updateLeaveService = async (id, data) => API.put(`/leaves/${id}`, data);

export const inactiveLeaveService = async (id, data) => API.put(`/leaves/${id}`, data);

export const getEmployeeLeaveService = async (id) => API.post('/leaves/remaining', { id });

export const applyLeaveService = async (data) => API.post('/leave/apply', data);

export const getRequestedLeaveService = async (params = {}) => {
	return API.get('/leave/applied/list', {
		params,
	});
};

export const updateRequestedLeaveService = async (id, data) =>
	API.put(`/leave/approve/${id}`, data);

export const getEmployeeRequestedLeaveService = async (data) => API.post('/leave/applied', data);

export const deleteMyRequestedLeaveService = async (id) =>
	API.delete(`/leave/applied/delete/${id}`);

/* =========================
   DEVICES
========================= */
export const addDeviceService = async (data) => API.post('/device/add', data);

export const getDeviceService = async () => API.get('/device/list');

export const updateDeviceService = async (id, data) => API.put(`/device/edit/${id}`, data);

export const deleteDeviceService = async (id, data) => API.delete(`/device/delete/${id}`, data);

export const connectDeviceService = async (data) => API.post('/device/connect', data);

export const disconnectDeviceService = async (data) => API.post('/device/disconnect', data);

/* =========================
   PUBLIC HOLIDAYS
========================= */
export const addPublicHoliday = async (data) => API.post('/holiday/add', data);

export const getPublicHoliday = async () => API.get('/holiday/list');

export const updatePublicHoliday = async (id, data) => API.put(`/holiday/edit/${id}`, data);

export const deletePublicHoliday = async (id) => API.delete(`/holiday/delete/${id}`);

/* =========================
   DASHBOARD
========================= */
export const getDashboardLeaves = async (id) => API.get(`/dashboard/leaves/${id}`);

export const getDashboardAttendance = async (id) => API.get(`/dashboard/attendance/${id}`);

export const getDashboardDetails = async () => API.get('/users/stats');

/* =========================
   CONFIGURATIONS
========================= */
export const getConfigsData = async () => API.get('/config/list');

export const addConfigsData = async (data) => API.post('/config/add', data);

export const editConfigsData = async (id, data) => API.put(`/config/edit/${id}`, data);

export const deleteConfigsData = async (id) => API.delete(`/config/delete/${id}`);

/* =========================
   ACTIVITY LOGS
========================= */
export const getActivityLogs = async ({ page = 1, limit = 10, search = '' } = {}) =>
	API.get('/activity-logs', {
		params: { page, limit, search },
	});

/* =========================
   SYSTEM LOGS
========================= */
export const getSystemLogs = async ({
	page = 1,
	limit = 10,
	search = '',
	startDate = '',
	endDate = '',
} = {}) =>
	API.get('/system-logs', {
		params: { page, limit, search, startDate, endDate },
	});
